import type { CSSProperties, HTMLAttributes, ReactNode } from "react";
import { BackgroundLogin } from "@/assets/images";

interface AppBackgroundProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

/**
 * Wrapper que aplica o fundo padronizado do app:
 *
 * - `data-app-bg=""` → ativa a regra `[data-app-bg]` em `src/index.css`,
 *   que empilha a imagem topográfica com uma overlay semi-transparente
 *   por tema (sem overlay no light, zinc 80% no dark).
 * - `bg-background` → garante a cor de fundo do tema como base, abaixo
 *   da overlay/imagem.
 * - `--bg-topo` → custom property consumida pela mesma regra; aponta
 *   para o asset resolvido pelo Vite em build-time.
 *
 * Usar este componente em qualquer tela "full-bleed" do app
 * (MainTemplate, telas de auth, loadings) garante coerência visual e
 * suporte automático a light/dark.
 */
export const AppBackground = ({
  className,
  style,
  children,
  ...rest
}: AppBackgroundProps) => {
  return (
    <div
      {...rest}
      data-app-bg=""
      className={["bg-background", className].filter(Boolean).join(" ")}
      style={
        {
          ...style,
          "--bg-topo": `url(${BackgroundLogin})`,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
};

export default AppBackground;
